/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_One_Drive_Ingest_SuccessInputs */

const es_tools_one_drive_ingest_success = /** @type {(inputs: Tools_One_Drive_Ingest_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos de OneDrive ingestados`)
};

const en_tools_one_drive_ingest_success = /** @type {(inputs: Tools_One_Drive_Ingest_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OneDrive files ingested`)
};

/**
* | output |
* | --- |
* | "OneDrive files ingested" |
*
* @param {Tools_One_Drive_Ingest_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_one_drive_ingest_success = /** @type {((inputs?: Tools_One_Drive_Ingest_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_One_Drive_Ingest_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_one_drive_ingest_success(inputs)
	return en_tools_one_drive_ingest_success(inputs)
});
export { tools_one_drive_ingest_success as "tools.one_drive.ingest_success" }